module.exports = __webpack_public_path__ + "img/st-8.40a9dd7b.png";